import { FC } from "react";

import __ from "web/Layout/Translations";

import formatNumber from "web/utils/data/parser/number/formatNumber";

import { useGetCustomerDetailsQuery } from "web/features/customer/customerApiSlice";

import classes from "./points.scss";

interface IPanelItemPointsProps {
  amount: number;
}

const PanelItemPoints: FC<IPanelItemPointsProps> = ({ amount }) => {
  const { data: customerData } = useGetCustomerDetailsQuery();
  const { language } = customerData || {};

  const engClassName = language === "en_GB" ? classes.eng : "";

  const pointsText = __("pkt");
  const pointsFormatted = `${formatNumber(amount)}`.replace(/ /g, "");

  return (
    <>
      <span className={`${classes.root} ${engClassName}`}>
        {pointsFormatted}
      </span>
      <span className={`${classes.text} ${engClassName}`}>{pointsText}</span>
    </>
  );
};

export default PanelItemPoints;
